import React, { Fragment, useState, useEffect, useRef } from 'react'
import TabsView from './TabsView'
import { isJDiwork, getUrlParams, getBillNoByPath, info, uuid, getMultiLocale, closeWin } from "../util"

export default function FragmentRoot(props) {
  // 解析页面query和billno，工作台打开的页面才会有query和billNo
  const mQuery = props.query || getUrlParams(window.location.href)
  // 兼容全局联查，从mQuery解析单据编码
  const billNo = props.billNo || props.match?.params?.billNo || mQuery.billNo || mQuery.billno || getBillNoByPath(window.location.href)

  // 页面历史堆栈
  const tabsData = useRef({});
  // 当前页面信息
  const [tabsState, setTabsState] = useState({})
  // 根据billNo获取历史页面堆栈的页面信息
  const getHistoryParams = (billNo) => {
    if (!billNo) {
      billNo = tabsData.current.activeKey;
    }
    const exists = tabsData.current.panes.find(p => p.billNo === billNo)
    return {
      query: exists?.query,
      params: exists?.params,
      status: exists?.status,
    }
  }
  // 页面push的时候补全的参数
  const parseQuery = (query) => {
    const currentPane = getHistoryParams()
    const newQuery = {
      domainKey: currentPane.query?.domainKey || mQuery.domainKey,
      serviceCode: currentPane.query?.serviceCode || mQuery.serviceCode,
      terminalType: mQuery.terminalType,
      busiObj: currentPane.query?.busiObj || mQuery.busiObj,
      ...query 
    }
    if (mQuery.transtype !== undefined) {
      newQuery.transtype = mQuery.transtype
    }
    if (mQuery.metaCache !== undefined) {
      newQuery.metaCache = mQuery.metaCache
    }
    return newQuery
  }
  // 获取工作台用户偏好配置
  const getGeneralSetting = () => {
    const generalSetting = {}
    if (isJDiwork()) {
      let businessPreferConfig = {}
      try {
        // 未去iframe的待办页面，要从window.parent里找
        const diworkContextFun = window.diworkContext || window.parent.diworkContext
        businessPreferConfig = JSON.parse(diworkContextFun?.().businessPreferConfig)
      } catch (error) {
        console.info("工作台访问出错：", error);
      }
      businessPreferConfig.commonSetOptions?.forEach(item => {
        generalSetting[item.configCode] = item.configCodeValue
      })
    }
    return generalSetting
  }

  // 正常页面打开的单据，要传递的history
  const tabsHistory = () => {
    return {
      getGeneralSetting,
      getHistoryParams,
      push: function ({ uiType, billNo, query, params = {}, status, ...other }) {
        // 兼容other里用户有传title的情况
        if (other.title) params.title = other.title
        // 工作台用户偏好配置中设置打开页面要以新页签的方式
        if (getGeneralSetting().tabOpenMode === '1') {
          const paramsTem = { ...params }
          let statusText = ""
          switch (status) {
            case "edit":
              statusText = lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B8002E', '编辑', undefined, { returnStr: true })
              break;
            case "copy":
              statusText = lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B8002F', '复制', undefined, { returnStr: true })
              break;
            case "add":
              statusText = lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80030', '新增', undefined, { returnStr: true })
              break;
            case "browse":
              statusText = paramsTem.code?.slice(-4) || ""
              break;
            default:
              break;
          }
          const privateCode = paramsTem.code ? paramsTem.code : paramsTem.mode === 'add' ? uuid(6, 10) : ""
          const locale = getMultiLocale();
          const title = paramsTem.title || (statusText + (locale === 'zh_CN' ? '' : ' ') + (props.diworkParams?.iframeTitle || document.title) + (locale === 'zh_CN' ? '' : ' ') + (status === 'browse' ? lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B80031', '详情', undefined, { returnStr: true }) : ""))
          window.jDiwork.openService(query?.serviceCode || paramsTem?.serviceCode || mQuery.serviceCode, { ...parseQuery(query), billNo }, {
            title: typeof title === 'object' ? title[locale] : title,
            code: `${billNo}_${privateCode}`,
            serviceType: 'ynf',
            data: {
              pane: { query: parseQuery(query), billNo, params: paramsTem, status },
              isMergeFlag: true
            },
            filterPermission: paramsTem.filterPermission ?? true // 打开页签时是否要判断权限
          })
          return
        }
        if (uiType === 'modal') {
          // 此处的openModal是在pageStore里往history里塞的方法
          this.openModal({ billNo, query, params })
        } else {
          const exists = tabsData.current.panes.find(p => p.billNo == billNo)
          // 历史栈里不存在的话就在tabsData里加一个
          if (!exists) {
            // diworkCode是工作台页签的code，push的时候要把diworkCode传到新页面的param里，否则新页面openModal会全屏
            params.diworkCode = props.diworkCode || props.params?.diworkCode
            tabsData.current.panes.push({ query: parseQuery(query), billNo, params, status })
          }
          tabsData.current.activeKey = billNo
          const currentPane = tabsData.current.panes.find(p => p.billNo == tabsData.current.activeKey)
          currentPane.params ? currentPane.params = Object.assign({}, currentPane.params, params) : null;

          // params里有title参数的话，实时修改标题
          if (isJDiwork()) {
            const currentPane = tabsData.current.panes.find(p => p.billNo == tabsData.current.activeKey)
            currentPane.params.title && props.diworkCode && jDiwork.updateService(props.diworkCode, { title: currentPane.params.title })
          }
          setTabsState({ ...tabsData.current })
        }
      },
      goBack: function (options = {}) {
        let { billNo, params } = options;
        if (!billNo) {
          billNo = tabsData.current.activeKey;
        }
        // 清掉上翻下翻的缓存
        sessionStorage.removeItem(`moveActionParams_${billNo}`)
        const isSinglePane = tabsData.current.panes.length < 2;
        // 最后一页
        if (isSinglePane) {
          // 如果当前单据是在窗口里的页面，且是最后一页，goback就是关闭窗口的方法
          if (props.closeDialog) {
            props.closeDialog()
            return
          }
          if (typeof options.callback === 'function') {
            options.callback();
          }
          if (options.sourcePage !== 'bizFlowWorkBench') {
            // 工作台用户偏好配置中设置打开页面要以新页签的方式
            if (getGeneralSetting().tabOpenMode === '1') {
              setTimeout(() => {
                // TODO: 刷新前一个页面这样写貌似不对？
                window.jDiwork.updateService({ serviceCode: props.serviceCode }, { tnsKey: Date.now() });
              }, 0)
              window.jDiwork.closeWin();
              return
            }
            closeWin();
          }
          return
        }
        const existsIndex = tabsData.current.panes.findIndex(p => p.billNo == billNo)
        const exists = tabsData.current.panes[existsIndex]
        if (!exists) {
          if (typeof options.callback === 'function') {
            options.callback();
          }
          info(`${lang.templateByUuid('UID:P_CORE-YNF-FE_18950B5405B8002D', '没有找要关闭的页面')}${billNo}`)
          return
        }
        tabsData.current.panes = tabsData.current.panes.filter((p) => p.billNo != billNo)
        tabsData.current.activeKey = tabsData.current.panes[tabsData.current.panes.length - 1].billNo
        const newTabsData = { ...tabsData.current }
        params ? newTabsData.panes[newTabsData.panes.length - 1].params = Object.assign({}, newTabsData.panes[newTabsData.panes.length - 1].params, params) : null;

        // 返回的时候，从params里取工作台页签的标题，没有的话从props.diworkParams?.iframeTitle里拿
        if (isJDiwork()) {
          const currentPane = newTabsData.panes.find(p => p.billNo == newTabsData.activeKey)
          const title = currentPane.params.title || props.diworkParams?.iframeTitle || document.title
          title && props.diworkCode && jDiwork.updateService(props.diworkCode, { title })
        }
        setTabsState({ ...newTabsData })
      }
    }
  }

  useEffect(() => {
    if (props.diworkParams?.isMergeFlag && props.diworkParams?.pane) {
      // 初始化新开页签时传递的pane
      tabsData.current = {
        activeKey: billNo, panes: [{
          ...props.diworkParams.pane, params: {
            // 这地方的顺序不要轻易动
            billType: props.billType,
            ...props.diworkParams.pane.params,
            diworkCode: props.diworkCode,
            title: props.diworkParams.iframeTitle
          }
        }]
      }
    } else {
      const params = {
        // 这地方的顺序不要轻易动
        diworkCode: props.diworkCode,
        billType: props.billType,
        ...props.params,
      }
      // 记录第一页的title
      if (props.diworkParams?.iframeTitle) params.title = props.diworkParams.iframeTitle
      tabsData.current = {
        activeKey: billNo, panes: [{ billNo, query: mQuery, history: tabsHistory(), params }]
      }
    }
    setTabsState(tabsData.current)
  }, [billNo])

  return (
    <Fragment>
      <TabsView {...props} tabs={tabsState} query={mQuery} history={tabsHistory()} />
    </Fragment>
  )
}
